import { render, staticRenderFns } from "./AnonymousLogin.vue?vue&type=template&id=48b21fa4&scoped=true"
import script from "./AnonymousLogin.vue?vue&type=script&lang=js"
export * from "./AnonymousLogin.vue?vue&type=script&lang=js"
import style0 from "./AnonymousLogin.vue?vue&type=style&index=0&id=48b21fa4&prod&lang=css"
import style1 from "./AnonymousLogin.vue?vue&type=style&index=1&id=48b21fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b21fa4",
  null
  
)

export default component.exports